// extracted by mini-css-extract-plugin
export default {"root":"fG69p5","rotate":"IKk2rK","circle":"EgFotp","dash":"W9wd3C"};